import React from "react";
import { ContentGrid } from "../styles";
import { Card, Button, Pill } from "../components";
import { TableContainer, TableHeader, TableRow, TableCell } from "../styles";

const AuditView = ({ audit, setAudit, pushToast, uid }) => {
  return (
    <ContentGrid>
      <Card title="Audit Log" icon="log" right={<Pill tone="c">Immutable-ready • Exportable</Pill>}>
        <ContentGrid>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <Pill>Actor: user/system</Pill>
              <Pill tone="d">Severity: low/med/high</Pill>
            </div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <Button variant="sec" onClick={() => pushToast("Audit", "Export generated (demo)")}>Export</Button>
              <Button
                variant="sec"
                onClick={() => {
                  setAudit((s) => [{ id: uid(), ts: "2026-01-08 08:55", actor: "system", type: "Compliance", detail: "On-chain anchoring scheduled (demo)", severity: "low" }, ...s]);
                  pushToast("Audit", "Anchoring scheduled");
                }}
              >
                Anchor on-chain
              </Button>
            </div>
          </div>

          <TableContainer>
            <TableHeader columns="170px 110px 140px 1fr 110px">
              <div>Timestamp</div>
              <div>Actor</div>
              <div>Type</div>
              <div>Detail</div>
              <div>Severity</div>
            </TableHeader>
            {audit.map((a) => (
              <TableRow key={a.id} columns="170px 110px 140px 1fr 110px">
                <TableCell bold>{a.ts}</TableCell>
                <TableCell>{a.actor}</TableCell>
                <TableCell>{a.type}</TableCell>
                <TableCell>{a.detail}</TableCell>
                <TableCell>
                  <Pill tone={a.severity === "high" ? "b" : a.severity === "med" ? "c" : "d"}>{a.severity}</Pill>
                </TableCell>
              </TableRow>
            ))}
          </TableContainer>
        </ContentGrid>
      </Card>
    </ContentGrid>
  );
};

export default AuditView;
